import { Box, BoxProps, SizableText, SmartLink, XStack, YStack } from '@my/ui'
import { UserAvatar } from 'app/features/user/components'
import { Chat } from 'app/types'
import { formatTimeToNow } from 'app/utils/format-time-to-now'

export interface ChatCardProps extends Chat {}

export const ChatCard = ({ id, user, lastMessage, ...props }: ChatCardProps & BoxProps) => {
  return (
    <SmartLink
      Component={Box}
      href={`/groups/chat/${id}`}
      gap="$3.5"
      pressable
      shadowOpacity={0.05}
      {...props}
    >
      <UserAvatar src={user.avatar.medium} alt={user.fullName} width={44} height={44} />
      <YStack gap="$1" flex={1}>
        <SizableText size="$5" fow="600" numberOfLines={1}>
          {user.fullName}
        </SizableText>
        {lastMessage && (
          <XStack jc="space-between" gap="$2" flex={1}>
            <SizableText size="$1" numberOfLines={1}>
            {user.id !== lastMessage?.user.id ? 'You: ' : ''} {lastMessage.message}
            </SizableText>
            <SizableText size="$1" whiteSpace="nowrap">
              {formatTimeToNow(lastMessage.createdAt)}
            </SizableText>
          </XStack>
        )}
      </YStack>
    </SmartLink>
  )
}
